import 'moment-timezone';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { SplitButton } from 'primereact/splitbutton';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import CreateBrand from "./CreateBrand";
import UpdateBrand from "./UpdateBrand";
import ModalDeleteBrand from "./ModalDeleteBrand";
import { FaTrashAlt } from 'react-icons/fa';
import ModalDeleteBrandMultiple from './ModalDeleteBrandMultiple';

const TableBrand = () => {
    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const inputRef = useRef();
    const timeout = useRef();

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const [selectAll, setSelectAll] = useState(false);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [brands, setBrands] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 15,
        page: 0
    });

    const [toggledClearRows, setToggleClearRows] = useState(false);

    const [showUpdate, setShowUpdate] = useState(false);
    const [updateData, setUpdateData] = useState({});

    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    const [showDeleteMultiple, setShowDeleteMultiple] = useState(false);

    const [modalCreate, setModalCreate] = useState(false);

    const isSelectable = (data) => data.id != 0;

    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);

    const loadLazyData = () => {
        setLoading(true);

        fetch(getEndpointUrl() + `/v2/car_brand?page=${lazyParams.page}&per_page=${lazyParams.rows}&query=${globalFilterValue}&v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setTotalRecords(json.results.total);
                setBrands(json.results.data);
            }
            setLoading(false);
        });
    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    useEffect(() => {
        return () => loadLazyData();
    }, [lazyParams]);

    useEffect(() => {
        clearTimeout(timeout.current);

        if (!globalFilterValue.trim()) {
            loadLazyData()
            return
        }
        timeout.current = setTimeout(() => {
            loadLazyData();
        }, 600);
    }, [globalFilterValue]);

    const onGlobalFilterChange = (e) => {
        setLoading(true);
        lazyParams.page = 0;
        setTotalRecords(0);
        setBrands([]);

        const value = e.target.value;

        setGlobalFilterValue(value);
    };

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedBrands(value);
        setSelectAll(value.length === totalRecords);
    }

    const header = (
        <Row>
            <Col md={4} sm={12} className="my-2">
                <h5 className="me-auto fw-bold pt-2">Master Data Merek</h5>
            </Col>
            <Col md={5} sm={12} className="my-2">
                <div className="d-md-flex">
                    <div className="ms-auto">
                        {selectedBrands?.length ?
                            <Button key="delete" onClick={(e) => {
                                setShowDeleteMultiple(true);
                                setToggleClearRows(!toggledClearRows);
                            }} variant="danger" className="me-3"><FaTrashAlt /> ({selectedBrands.length}) Hapus yang terpilih</Button> : ''
                        }
                        <Link to={`#`} title="Input Merek" onClick={(e) => setModalCreate(true)} className="btn btn-success me-3"><AiOutlinePlus className="me-2" /> Input Data</Link>
                        <CreateBrand onCallback={(e) => onCallback(e)} show={modalCreate} close={(e) => setModalCreate(false)} />
                    </div>
                </div>
            </Col>
            <Col md={3} sm={12} className="my-2">
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText ref={inputRef} className="p-inputtext-sm" onChange={onGlobalFilterChange} placeholder="Pencarian..." style={{ minWidth: '100%' }} />
                </div>
            </Col>
        </Row>
    );

    const kelolaBodyTemplate = (rowData) => {
        return <SplitButton size="small" label="Edit" icon="pi pi-pencil"
            onClick={(e) => {
                setShowUpdate(true);
                setUpdateData(rowData);
            }}
            model={[
                {
                    label: 'Hapus',
                    icon: 'pi pi-trash',
                    disabled: userLogin.role != 'admin',
                    command: () => {
                        setShowDelete(true);
                        setDeleteData(rowData);
                    }
                }
            ]} severity="secondary" text />
    };

    const onCallback = useCallback((e) => {
        loadLazyData();
    }, []);

    return (
        <Container className="mt-3">
            <DataTable
                value={brands}
                lazy
                size="small"
                responsiveLayout="scroll"
                dataKey="id"
                header={header}
                globalFilterFields={['companyName', 'originCountry']}
                emptyMessage="Tidak ada data yang ditemukan."
                paginator
                first={lazyParams.first}
                rows={15}
                totalRecords={totalRecords}
                onPage={onPage}
                loading={loading}
                selection={selectedBrands}
                onSelectionChange={onSelectionChange}
                selectAll={selectAll}>
                <Column selectionMode="multiple" />
                <Column field="id" header="ID" />
                <Column field="companyName" header="NAMA MEREK" />
                <Column field="originCountry" header="NEGARA ASAL" />
                <Column header="KELOLA" body={kelolaBodyTemplate} />
            </DataTable>
            <UpdateBrand row={updateData} onCallback={(e) => onCallback(e)} show={showUpdate} close={() => setShowUpdate(false)} />
            <ModalDeleteBrand row={deleteData} onCallback={(e) => onCallback(e)} show={showDelete} close={() => setShowDelete(false)} />
            <ModalDeleteBrandMultiple dataDelete={selectedBrands} onCallback={(e) => onCallback(e)} show={showDeleteMultiple} close={() => setShowDeleteMultiple(false)} />
        </Container>
    );
}

export default TableBrand;
